<template>
  <span
    class="brand-signature"
    :style="brandStyle"
    :class="[
      `brand-signature--${placement}`,
      `brand-signature--${theme}`,
      `brand-signature--${size}`,
      `brand-signature--${appearance}`,
    ]"
  >
    <img
      :src="src"
      :alt="alt"
      :class="logoClass"
      class="brand-signature__logo"
    />
    <span class="brand-signature__credit" aria-label="by Anzera">
      <span class="brand-signature__by">by</span>
      <span class="brand-signature__anzera">Anzera</span>
    </span>
  </span>
</template>

<script>
export default {
  name: "BrandSignature",
  props: {
    src: {
      type: String,
      required: true,
    },
    alt: {
      type: String,
      default: "Softinya LMS by Anzera",
    },
    logoClass: {
      type: [String, Array, Object],
      default: "",
    },
    logoWidth: {
      type: String,
      default: "",
    },
    logoHeight: {
      type: String,
      default: "",
    },
    placement: {
      type: String,
      default: "below",
      validator: (value) => ["below", "beside"].includes(value),
    },
    theme: {
      type: String,
      default: "dark",
      validator: (value) => ["dark", "light", "muted"].includes(value),
    },
    size: {
      type: String,
      default: "medium",
      validator: (value) => ["small", "medium", "large"].includes(value),
    },
    appearance: {
      type: String,
      default: "badge",
      validator: (value) => ["badge", "plain"].includes(value),
    },
  },
  computed: {
    brandStyle() {
      const style = {};
      if (this.logoWidth) style["--brand-logo-width"] = this.logoWidth;
      if (this.logoHeight) style["--brand-logo-height"] = this.logoHeight;
      return Object.keys(style).length ? style : null;
    },
  },
};
</script>

<style scoped>
.brand-signature {
  display: inline-flex;
  max-width: 100%;
  line-height: 1;
  vertical-align: middle;
}

.brand-signature--below {
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
}

.brand-signature--beside {
  align-items: flex-end;
  gap: 8px;
}

.brand-signature__logo {
  display: block;
  width: var(--brand-logo-width, auto);
  height: var(--brand-logo-height, auto);
  max-width: 100%;
  object-fit: contain;
}

.brand-signature__credit {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  padding: 4px 7px;
  border-radius: 999px;
  white-space: nowrap;
  font-family: inherit;
  font-size: 11px;
  font-weight: 400;
  letter-spacing: 0.04em;
  text-transform: none;
}

.brand-signature--small .brand-signature__credit {
  padding: 3px 6px;
  font-size: 9px;
}

.brand-signature--large .brand-signature__credit {
  padding: 5px 9px;
  font-size: 13px;
}

.brand-signature--dark .brand-signature__credit {
  color: #596173;
  background: rgba(121, 113, 255, 0.1);
}

.brand-signature--muted .brand-signature__credit {
  color: #646b79;
  background: rgba(121, 113, 255, 0.1);
}

.brand-signature--light .brand-signature__credit {
  color: #fff;
  background: rgba(255, 255, 255, 0.16);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.16);
}

.brand-signature--plain .brand-signature__credit {
  padding: 0;
  background: transparent;
  box-shadow: none;
}

.brand-signature__by {
  font-weight: 300;
  font-style: italic;
  opacity: 0.82;
}

.brand-signature__anzera {
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #7971ff;
}

.brand-signature--light .brand-signature__anzera {
  color: #fff;
}
</style>
